import cn from 'classnames'

import { VideoProps } from './Video.types'

export const Video = (props: VideoProps) => {
    const { className, src, poster, title } = props

    if (src.includes('youtube.com') || src.includes('youtu.be') || src.includes('vimeo.com')) {
        const getEmbedUrl = (url: string) => {
            if (url.includes('youtube.com/watch')) {
                const videoId = url.split('v=')[1]?.split('&')[0]
                return `https://www.youtube.com/embed/${videoId}`
            }
            if (url.includes('youtu.be')) {
                const videoId = url.split('youtu.be/')[1]?.split('?')[0]
                return `https://www.youtube.com/embed/${videoId}`
            }
            if (url.includes('vimeo.com')) {
                const videoId = url.split('vimeo.com/')[1]?.split('?')[0]
                return `https://player.vimeo.com/video/${videoId}`
            }
            return url
        }

        return (
            <div className={cn('relative w-full', className)}>
                <div className='aspect-video w-full'>
                    <iframe
                        src={getEmbedUrl(src)}
                        title={title}
                        className='w-full h-full rounded-lg'
                        allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                        allowFullScreen
                    />
                </div>
            </div>
        )
    }

    return (
        <div className={cn('relative w-full', className)}>
            <div className='aspect-video w-full'>
                <video
                    className='w-full h-full rounded-lg'
                    controls
                    poster={poster}
                    preload='none'
                >
                    <source src={src} type='video/mp4'/>
                    Your browser does not support the video tag.
                </video>
            </div>
        </div>
    )
}
